<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width: 100%">
        <el-tab-pane name="PCHIUV" :label="$t('CargoMsg.Cargo_PCHIUV')">
          <div class="grid-view">
            <div class="main-content">
              <search-item config-module="231506" :show-simple="false" :expand-adv="true" :custom-search-items="customSearchItems" no="1" @advSearchItemCallBack="toAdvancedQuery">
                <template slot="operations">
                  <el-button type="primary" no="2" @click="toAudit">{{ $t('CargoMsg.Cargo_Audit') }}</el-button>
                </template>
              </search-item>
              <div class="section grid-wrapper">
                <cargo-ag-grid
                  config-module="23150103"
                  :grid-options="gridOptions"
                  :column-defs="columnDefs"
                  :row-data="rowData"
                  no="3"
                  @gridReady="params=>{gridApi=params.api}"
                />
              </div>
              <div class="pagination-wrapper">
                <cargo-pagination
                  config-module="23150103"
                  :page.sync="filter.pageNum"
                  :limit.sync="filter.pageSize"
                  :total="total"
                  no="4"
                  @pagination="toAdvancedQuery()"
                />
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnTagRenderer from '@/components/Cargo/Common/ColumnTagRenderer'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { queryQuotationClientPageable, agreeQuotationClients, refuseQuotationClients } from '@/api/sales/quotationClient'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { OPERATOR_IN } from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'

export default {
  name: 'CRMScheduleCustomerManager',
  components: { searchItem },
  data() {
    const defaultSearchFields = []

    // 所属城市
    let searchField = new AdvancedSearchField()
    searchField.action = AdvancedSearchField.UPDATE_ACTION
    searchField.itemType = 'countryAreaCascader'
    searchField.itemCondition = [OPERATOR_IN]
    searchField.defaultConditionVal = OPERATOR_IN.code
    searchField.fieldType = 'FIELD_TEXT'
    searchField.itemName = 'quotationClient.PROVINCE'
    searchField.itemLabel = 'CargoMsg.Cargo_City'
    searchField.defaultValue = []
    defaultSearchFields.push(searchField.formatObj2Json())

    // CARGO-45606 CRM模块中，增加合作伙伴简称字段
    searchField = new AdvancedSearchField()
    searchField.action = AdvancedSearchField.UPDATE_ACTION
    searchField.itemType = 'input'
    searchField.fieldType = 'FIELD_TEXT'
    searchField.itemName = 'quotationClient.SHORT_NAME'
    searchField.itemLabel = 'CargoMsg.Cargo_Abbreviation'
    searchField.defaultValue = []
    defaultSearchFields.push(searchField.formatObj2Json())

    const customSearchItems = defaultSearchFields

    return {
      activeTabName: 'PCHIUV',
      customSearchItems,
      filter: {
        conditions: [],
        roleMap: {},
        branchId: 0,
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      gridOptions: {
        frameworkComponents: {
          ColumnTagRenderer
        },
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_ClientNo'),
          field: 'clientId',
          colId: 'clientId',
          valueFormatter: params => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'name',
          colId: 'name',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          colId: 'englishName',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_BranchCompany'),
          field: 'branchId',
          colId: 'branchId',
          valueFormatter: params => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ScaleOfCompanyEmployees'),
          field: 'companySize',
          colId: 'companySize',
          valueFormatter: params => {
            if (!params.value) return ''
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RegisteredCapitalIn10Thousand'),
          field: 'registeredCapital',
          colId: 'registeredCapital',
          valueFormatter: params => {
            if (!params.value) return ''
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CreatedDate'),
          field: 'dateCreated',
          colId: 'dateCreated',
          valueFormatter: params => {
            if (!params.value) return ''
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ClientStatus'),
          field: 'customerStatusCode',
          colId: 'customerStatusCode',
          cellRendererSelector: params => {
            let color = ''
            switch (params.value) {
              case '0': // 潜在阶段
                color = '#8DCE64'
                break
              case '1': // 意向阶段
                color = '#00A795'
                break
              case '2': // 商务阶段
                color = '#00A6F4'
                break
              case '3': // 合作阶段
                color = '#5469BA'
                break
            }
            return {
              component: 'ColumnTagRenderer',
              params: {
                color,
                value: ColumnUtils.customerStatusCodeToColumnLabelFun(params.value)
              }
            }
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerType'),
          field: 'companyTypeCode',
          colId: 'companyTypeCode',
          valueFormatter: params => {
            return ColumnUtils.companyTypeCodeToColumnLabelFun(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SourceOfClient'),
          field: 'sourceType',
          colId: 'sourceType',
          hidden: !this.showSourceType,
          valueFormatter: params => {
            return ColumnUtils.sourceTypeCodeToColumnLabelFun(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_FirstContactDate'),
          field: 'firstMeetDate',
          colId: 'firstMeetDate',
          valueFormatter: params => {
            if (!params.value) return ''
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Competitor'),
          field: 'competitorCompany',
          colId: 'competitorCompany',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Sales'),
          field: 'ownerId',
          colId: 'ownerId',
          valueFormatter: params => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_30DaysShpt'),
          field: 'freightVolume30',
          colId: 'freightVolume30',
          valueFormatter: params => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_60DaysShpt'),
          field: 'freightVolume60',
          colId: 'freightVolume60',
          valueFormatter: params => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_90DaysShpt'),
          field: 'freightVolume90',
          colId: 'freightVolume90',
          valueFormatter: params => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Over90DaysShpt'),
          field: 'freightVolumeGt90',
          colId: 'freightVolumeGt90',
          valueFormatter: params => {
            if (!params.value) return '0'
            return params.value.toString()
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_DaysNotFollowedUp'),
          field: 'unAskDays',
          colId: 'unAskDays',
          hidden: true,
          valueFormatter: params => {
            if (!params.value) return '0'
            return ColumnUtils.formatUnAskDays(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PreferredPort'),
          field: 'seaPortCode',
          colId: 'seaPortCode',
          valueFormatter: params => {
            if (!params.value) return ''
            return ColumnUtils.likeSeaPortCode(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_PreferredAirport'),
          field: 'airPortCode',
          colId: 'airPortCode',
          valueFormatter: params => {
            if (!params.value) return ''
            return ColumnUtils.likeAirPortCode(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerContactChannel'),
          field: 'customerContactChannel',
          colId: 'customerContactChannel',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.customerContactChannelLabelFun(params.value)
          },
          width: 140
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Country'),
          field: 'country',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, this.isZh ? 'chineseName' : 'name')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Abbreviation'),
          field: 'shortName',
          width: 150,
          hide: true
        }
      ],
      rowData: [],
      selectedNode: null,
      gridApi: null
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  mounted() {
    SalesUtil.checkCrmExpire(this.$route, this.$router)
  },
  methods: {
    toAdvancedQuery(conditions) {
      if (conditions) {
        // 销售不为空的
        conditions.push(new AdvancedSearchOption(null, 'quotationClient.OWNER_ID', 0, AdvancedSearchConsts.OPERATOR_UNEQUAL.code).formatObj2Json())
        // 审核状态（未审核和已拒绝）能再次查询
        conditions.push(new AdvancedSearchOption(null, 'quotationClient.APPROVED_STATE', [0, 3], AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
        // 是否有效
        conditions.push(new AdvancedSearchOption(null, 'quotationClient.ACTIVE', 1).formatObj2Json())
        const roleMap = {}
        // 查询销售组长本人及组员
        if (!this.$store.getters.isAdmin) {
          roleMap.checkGroupLeaderOwner = true
        }
        if (AdvancedSearchOption.hasField('quotationClient.DUE_TIME', conditions)) {
          const option = AdvancedSearchOption.removeOption('quotationClient.DUE_TIME', conditions)
          roleMap.dueTime = { 'value': option.value, 'operator': option.operator }
        }
        // 所属城市
        if (AdvancedSearchOption.hasField('quotationClient.PROVINCE', conditions)) {
          const option = AdvancedSearchOption.removeOption('quotationClient.PROVINCE', conditions)
          const countryArr = []
          const provinceArr = []
          const cityArr = []
          const districtsArr = []
          for (const item of option.value) {
            switch (item.length) {
              case 1:
                countryArr.push(item[0])
                break
              case 2:
                provinceArr.push(item[1])
                break
              case 3:
                cityArr.push(item[2])
                break
              case 4:
                districtsArr.push(item[3])
                break
            }
          }
          if (countryArr.length > 0) {
            conditions.push({ ...option, fieldName: 'quotationClient.COUNTRY', value: countryArr })
          }
          if (provinceArr.length > 0) {
            conditions.push({ ...option, fieldName: 'quotationClient.PROVINCE', value: provinceArr })
          }
          if (cityArr.length > 0) {
            conditions.push({ ...option, fieldName: 'quotationClient.CITY', value: cityArr })
          }
          if (districtsArr.length > 0) {
            conditions.push({ ...option, fieldName: 'quotationClient.DISTRICTS', value: districtsArr })
          }
        }
        this.filter.conditions = conditions
        this.filter.roleMap = roleMap
        this.filter.branchId = this.$store.getters.currentOfficeId
        this.filter.pageNum = 1
      }
      const loading = getLoading4Cxt(this)
      queryQuotationClientPageable(this.filter).then(res => {
        const data = res.data
        this.rowData = data.list
        this.filter.pageNum = data.pageNum
        this.filter.pageSize = data.pageSize
        this.total = Number(data.total)
        this.gridApi.clearFocusedCell()
      }).finally(() => {
        loading.close()
      })
    },
    async toAudit() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectEventToApprove'))
        return
      }
      const action = await this.$confirm(this.$t('CargoMsg.Cargo_VerificationPassed'), this.$t('CargoMsg.Cargo_Audit'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Agree'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Refuse'),
        type: 'warning',
        closeOnClickModal: false,
        distinguishCancelAndClose: true
      }).then(t => t).catch(c => c)
      if (action === 'close') {
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        if (action === 'confirm') {
          const res = await agreeQuotationClients(rows)
          if (res.data.length > 0) {
            this.$message.success(this.$t('CargoMsg.Cargo_CGS1RV', [res.data.length]))
          } else {
            return
          }
        } else if (action === 'cancel') {
          const res = await refuseQuotationClients(rows)
          if (res.data.length > 0) {
            this.$message.success(this.$t('CargoMsg.Cargo_RWSR', [res.data.length]))
          } else {
            return
          }
        }
      } finally {
        loading.close()
      }
      this.filter.pageNum = 1
      this.toAdvancedQuery()
    }
  }
}
</script>
